import { createSelector } from 'reselect';
import { convertPages } from 'utils/selectConversions';

export const pagesSelector = (state) => state.pages.pages;

export const pagesDropdownSelector = createSelector(
    pagesSelector,
    (apps) => {
        if (apps) {
            return convertPages(apps);
        }
    }
);
